export default __webpack_public_path__ + "static/media/pdg-logo-white.0f4f996e.svg";